
import fujiVisibleBuildings from "./fuji_visibleBuildings.json";
import sumihana_visibleBuildings from "./sumihana_visibleBuildings.json";
import tokyotower_visibleBuildings from "./tokyotower_visibleBuildings.json";

const MapSpecs = {
    "fuji3D": {
        description: "富士山🗻",
        longerDescription: "",
        mapGroup: "3D",
        buildingVisible: id => fujiVisibleBuildings[id],
    },
    "tokyotower": {
        description: "東京タワー🗼",
        longerDescription: "",
        mapGroup: "3D",
        buildingVisible: id => tokyotower_visibleBuildings[id],
    },
    "sumihana3D": {
        description: "隅田川花火🎆",
        longerDescription: "",
        mapGroup: "3D",
        buildingVisible: id => sumihana_visibleBuildings[id],
    },
    "all3D": {
        description: "全部🗻🗼🎆",
        longerDescription: "",
        mapGroup: "3D",
        buildingVisible: id => fujiVisibleBuildings[id] && tokyotower_visibleBuildings[id] && sumihana_visibleBuildings[id],
    },
    "fuji": {
        description: "富士山🗻が見える建物",
        mapGroup: "2D",
        longerDescription: "",
    },
    "rawTerrain": {
        description: "標高",
        mapGroup: "2D",
    },
    "height": {
        description: "🏢高さ",
        mapGroup: "2D",
    },
    "absHeight": {
        description: "🏢高さ（海抜）",
        mapGroup: "2D",
    },
};
export default MapSpecs;